module.exports = __webpack_public_path__ + "img/ee465a8.svg";